
import { mapGetters } from 'vuex'
export default {
  props: {
    guideType: {
      type: String,
      default: 'bras'
    }
  },
  computed: {
    ...mapGetters({
      currentCountryCode: 'frontend/currentCountryCode',
      currentLanguageCode: 'frontend/currentLanguageCode',
    }),
    sizeguideUrl () {
      const baseUrl = this.$config.sizeguideUrl
      const urlSuffix =
        this.guideType === 'stockings'
          ? `/bottoms/stockings?chart=${this.currentCountryCode?.toLowerCase()}&lang=${this.currentLanguageCode}`
          : `/?chart=${this.currentCountryCode?.toLowerCase()}&lang=${this.currentLanguageCode}`
      return baseUrl + urlSuffix
    }
  }
}
